import { PersistentState } from './type'
import { version } from '../version'

export const getDefaultPersistentState = (): PersistentState => {
  return {
    quoteGeneralInfo: {},
    formProgress: [],
    pageState: {},
    meta: { version, createdAt: new Date().toString() },
  }
}
